package com.sddamico.draftmachine.models

import com.sddamico.draftmachine.data.Sport
import kotlinx.serialization.Serializable

/** Frontend mirror of the jvmMain `models/PlayerPoolModels.kt` `PlayerPoolResponse`. */
@Serializable
data class PlayerPoolResponse(
  val id: String,
  val name: String,
  val sport: Sport? = null,
  val description: String? = null,
  /** Current public username for community attribution; owner email is never serialized. */
  val creatorUsername: String? = null,
  val isPublic: Boolean = false,
  val isOfficial: Boolean = false,
  val directPlayerCount: Int = 0,
  val childPoolCount: Int = 0,
  val totalPlayerCount: Int = 0,
)

/** Frontend mirror of the jvmMain `NewPlayerEntry` (CSV rows use the same shape). */
@Serializable
data class NewPlayerEntry(
  val name: String,
  val sport: Sport? = null,
  val team: String? = null,
  val teamShortName: String? = null,
  val position: String? = null,
  val adp: Double? = null,
  val adpPpr: Double? = null,
)

/** Frontend mirror of the jvmMain `CreatePoolRequest` — single-transaction pool create. */
@Serializable
data class CreatePoolRequest(
  val name: String,
  val description: String? = null,
  val sport: Sport? = null,
  val isPublic: Boolean = false,
  val players: List<NewPlayerEntry> = emptyList(),
  val childPoolIds: List<String> = emptyList(),
)

/** Frontend mirror of the jvmMain `UpdatePoolRequest`. */
@Serializable
data class UpdatePoolRequest(
  val poolId: String,
  val name: String,
  val description: String? = null,
  val sport: Sport? = null,
  val isPublic: Boolean = false,
)

/** Frontend mirror of the jvmMain `ClonePoolRequest`. */
@Serializable
data class ClonePoolRequest(
  val poolId: String,
  val name: String? = null,
)

/** Frontend mirror of the jvmMain `PlayerPoolDetailResponse`. */
@Serializable
data class PlayerPoolDetailResponse(
  val pool: PlayerPoolResponse,
  val children: List<PlayerPoolResponse> = emptyList(),
  val directPlayers: List<PlayerResponse> = emptyList(),
  val totalPlayerCount: Int = 0,
  val canEdit: Boolean = false,
)

/** Frontend mirror of the jvmMain `AddPlayerToPoolRequest`. */
@Serializable
data class AddPlayerToPoolRequest(
  val poolId: String,
  val playerId: String? = null,
  val player: NewPlayerEntry? = null,
)

/** Frontend mirror of the jvmMain `AddChildPoolRequest`. */
@Serializable
data class AddChildPoolRequest(
  val parentPoolId: String,
  val childPoolId: String,
)
